import React from "react";

import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";

import {
  AccessibilityTable,
  ResourceItem,
  ResourceList,
  Section,
  SubTitle,
  TableCell,
  TableHead,
  Text,
  TextContainer,
} from "./acessibility.styles";

export function AcessibilityPage() {
  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Acessibilidade" },
        ]}
      />

      <main id="content">
        <PageTitle>
          ACESSIBILIDADE
        </PageTitle>

        <TextContainer>


          {/* INTRODUÇÃO */}

          <Section>
            <SubTitle>
              Declaração de acessibilidade
            </SubTitle>

            <Text>
              A Prefeitura Municipal reafirma seu compromisso
              com a inclusão digital, acessibilidade,
              transparência pública e democratização
              do acesso à informação para todos os cidadãos.
            </Text>

            <Text>
              Este portal foi desenvolvido buscando atender
              às diretrizes do Modelo de Acessibilidade em
              Governo Eletrônico (eMAG), às recomendações
              internacionais WCAG (Web Content Accessibility
              Guidelines) do W3C e às boas práticas de
              acessibilidade digital aplicáveis à
              administração pública.
            </Text>

            <Text>
              O portal busca garantir condições adequadas
              de navegação para pessoas com deficiência,
              mobilidade reduzida, baixa visão,
              limitações motoras, limitações cognitivas
              e usuários de tecnologias assistivas.
            </Text>

            <Text>
              As funcionalidades de acessibilidade
              disponíveis incluem recursos de alto contraste,
              redimensionamento de fonte, navegação por
              teclado, compatibilidade com leitores de tela,
              estrutura semântica acessível e integração
              com ferramentas assistivas em Libras.
            </Text>

            <Text>
              Esta página apresenta os recursos de
              acessibilidade implementados,
              os padrões adotados pelo portal
              e os canais disponíveis para comunicação
              de barreiras digitais eventualmente
              identificadas pelos usuários.
            </Text>
          </Section>

          {/* RECURSOS */}

          <Section>
            <SubTitle>
              Recursos de acessibilidade disponíveis
            </SubTitle>

            <Text>
              O portal disponibiliza ferramentas
              e recursos voltados à promoção
              da acessibilidade digital,
              permitindo melhor experiência
              de navegação para usuários
              com deficiência ou limitações
              temporárias de uso.
            </Text>

            <ResourceList>

              <ResourceItem>
                Ferramenta de alto contraste
                para ampliação da legibilidade
                e melhor distinção visual
                dos elementos da interface.
              </ResourceItem>

              <ResourceItem>
                Redimensionamento de fonte
                através dos controles A+
                e A-, permitindo adaptação
                da leitura conforme a necessidade
                do usuário.
              </ResourceItem>

              <ResourceItem>
                Navegação por teclado
                utilizando atalhos padronizados
                conforme recomendações
                do Governo Federal.
              </ResourceItem>

              <ResourceItem>
                Compatibilidade com leitores
                de tela e tecnologias assistivas.
              </ResourceItem>

              <ResourceItem>
                Estrutura semântica organizada
                para navegação assistida
                e interpretação adequada
                por softwares especializados.
              </ResourceItem>

              <ResourceItem>
                Compatibilidade com navegação
                sem utilização de mouse.
              </ResourceItem>

              <ResourceItem>
                Integração com ferramentas
                de acessibilidade em Libras.
              </ResourceItem>

              <ResourceItem>
                Destaque visual de foco
                para navegação por teclado.
              </ResourceItem>

            </ResourceList>

            <Text>
              As ferramentas de acessibilidade
              permanecem disponíveis em todas
              as páginas do portal institucional.
            </Text>
          </Section>

          {/* ATALHOS */}

          <Section>
            <SubTitle>
              Atalhos de navegação
            </SubTitle>

            <Text>
              Este portal disponibiliza atalhos
              de teclado padronizados conforme
              as recomendações do Governo Federal
              e do Modelo de Acessibilidade
              em Governo Eletrônico (eMAG).
            </Text>

            <Text>
              Os atalhos permitem acesso rápido
              às principais áreas da página,
              facilitando a navegação por usuários
              que utilizam teclado,
              leitores de tela
              ou tecnologias assistivas.
            </Text>

            <AccessibilityTable>
              <caption>
                Tabela de atalhos de navegação
                disponíveis no portal
              </caption>

              <thead>
                <tr>

                  <TableHead scope="col">
                    Comando
                  </TableHead>

                  <TableHead scope="col">
                    Função
                  </TableHead>

                </tr>
              </thead>

              <tbody>

                <tr>
                  <TableCell>
                    Alt + 1
                  </TableCell>

                  <TableCell>
                    Ir para o conteúdo principal
                    da página
                  </TableCell>
                </tr>

                <tr>
                  <TableCell>
                    Alt + 2
                  </TableCell>

                  <TableCell>
                    Ir para o menu principal
                  </TableCell>
                </tr>

                <tr>
                  <TableCell>
                    Alt + 3
                  </TableCell>

                  <TableCell>
                    Ir para o campo de busca
                    do portal
                  </TableCell>
                </tr>

                <tr>
                  <TableCell>
                    Alt + 4
                  </TableCell>

                  <TableCell>
                    Ir para o rodapé do portal
                  </TableCell>
                </tr>

              </tbody>
            </AccessibilityTable>

            <Text>
              Dependendo do navegador utilizado,
              pode ser necessário utilizar combinações
              alternativas de teclas.
            </Text>

            <Text>
              No navegador Firefox,
              utilize Alt + Shift + número.
            </Text>

            <Text>
              Em dispositivos MacOS,
              utilize Ctrl + Option + número.
            </Text>

            <Text>
              Em navegadores Opera,
              utilize Shift + ESC + número.
            </Text>
          </Section>

          {/* LEITORES DE TELA */}

          <Section>
            <SubTitle>
              Leitores de tela e tecnologias assistivas
            </SubTitle>

            <Text>
              Este portal busca manter compatibilidade
              com leitores de tela, navegadores acessíveis
              e demais tecnologias assistivas utilizadas
              por pessoas com deficiência visual,
              baixa visão, deficiência motora
              ou limitações de navegação.
            </Text>

            <Text>
              A estrutura das páginas foi organizada
              utilizando marcação semântica,
              hierarquia de títulos,
              navegação por teclado
              e identificação adequada dos elementos
              interativos do portal.
            </Text>

            <Text>
              Recomendamos a utilização das seguintes
              ferramentas gratuitas de acessibilidade:
            </Text>

            <ResourceList>

              <ResourceItem>
                NVDA (NonVisual Desktop Access)
                — leitor de tela gratuito
                para sistema Windows.
              </ResourceItem>

              <ResourceItem>
                DOSVOX
                — sistema desenvolvido pela UFRJ
                voltado à acessibilidade digital
                para pessoas com deficiência visual.
              </ResourceItem>

              <ResourceItem>
                VLibras
                — ferramenta automática
                de tradução de conteúdos digitais
                para Libras.
              </ResourceItem>

            </ResourceList>

            <Text>
              Os recursos implementados neste portal
              permitem navegação assistida,
              leitura estruturada de conteúdo,
              identificação de áreas principais
              da página e melhor percepção visual
              dos elementos da interface.
            </Text>

            <Text>
              Caso o usuário identifique barreiras
              de acessibilidade incompatíveis
              com tecnologias assistivas,
              recomenda-se comunicar o problema
              através dos canais oficiais
              disponibilizados nesta página.
            </Text>
          </Section>

          {/* LEGISLAÇÃO */}

          <Section>
            <SubTitle>
              Legislação e padrões adotados
            </SubTitle>

            <Text>
              Este portal busca atender às diretrizes
              legais e técnicas relacionadas à
              acessibilidade digital,
              transparência pública
              e inclusão de usuários
              nos serviços eletrônicos
              disponibilizados pela administração pública.
            </Text>

            <Text>
              As práticas implementadas observam
              recomendações nacionais
              e internacionais de acessibilidade,
              usabilidade e estruturação semântica
              de conteúdo digital.
            </Text>

            <ResourceList>

              <ResourceItem>
                Lei nº 13.146/2015
                — Lei Brasileira de Inclusão
                da Pessoa com Deficiência.
              </ResourceItem>

              <ResourceItem>
                Lei nº 12.527/2011
                — Lei de Acesso à Informação.
              </ResourceItem>

              <ResourceItem>
                Lei nº 14.129/2021
                — Lei do Governo Digital.
              </ResourceItem>

              <ResourceItem>
                Lei nº 13.709/2018
                — Lei Geral de Proteção
                de Dados Pessoais (LGPD).
              </ResourceItem>

              <ResourceItem>
                Modelo de Acessibilidade
                em Governo Eletrônico (eMAG).
              </ResourceItem>

              <ResourceItem>
                Diretrizes WCAG
                (Web Content Accessibility Guidelines)
                do W3C.
              </ResourceItem>

            </ResourceList>

            <Text>
              O portal busca assegurar:
            </Text>

            <ResourceList>

              <ResourceItem>
                Navegação acessível
                em diferentes dispositivos.
              </ResourceItem>

              <ResourceItem>
                Compatibilidade com leitores
                de tela e tecnologias assistivas.
              </ResourceItem>

              <ResourceItem>
                Navegação sem dependência
                exclusiva do mouse.
              </ResourceItem>

              <ResourceItem>
                Contraste adequado
                para leitura de conteúdo.
              </ResourceItem>

              <ResourceItem>
                Organização semântica
                das informações.
              </ResourceItem>

              <ResourceItem>
                Identificação adequada
                de elementos interativos.
              </ResourceItem>

              <ResourceItem>
                Estrutura compatível
                com navegação por teclado.
              </ResourceItem>

              <ResourceItem>
                Disponibilidade contínua
                das ferramentas de acessibilidade.
              </ResourceItem>

            </ResourceList>

            <Text>
              A Prefeitura mantém esforços contínuos
              de atualização e melhoria
              dos recursos de acessibilidade digital,
              visando ampliar a inclusão
              e a transparência dos serviços públicos.
            </Text>
          </Section>

          {/* DADOS ABERTOS */}

          <Section>
            <SubTitle>
              Acessibilidade em documentos e dados públicos
            </SubTitle>

            <Text>
              Este portal busca garantir que documentos,
              relatórios, demonstrativos financeiros,
              atos administrativos e demais informações públicas
              sejam disponibilizados de maneira acessível,
              estruturada e compatível com tecnologias assistivas.
            </Text>

            <Text>
              A acessibilidade digital não se limita
              aos elementos visuais do portal,
              alcançando também a forma como
              os dados públicos são organizados,
              publicados e disponibilizados
              para consulta da sociedade.
            </Text>

            <Text>
              Sempre que possível,
              os documentos e bases de dados
              são disponibilizados em formatos abertos,
              estruturados e compatíveis
              com leitura automatizada,
              permitindo melhor reutilização,
              transparência e acessibilidade.
            </Text>

            <ResourceList>

              <ResourceItem>
                Arquivos em formato CSV
                para leitura estruturada de dados.
              </ResourceItem>

              <ResourceItem>
                Planilhas em formato XLSX
                compatíveis com softwares assistivos.
              </ResourceItem>

              <ResourceItem>
                Documentos em PDF pesquisável,
                permitindo seleção de texto
                e leitura por leitores de tela.
              </ResourceItem>

              <ResourceItem>
                Estruturas compatíveis
                com leitura automatizada
                por máquina.
              </ResourceItem>

              <ResourceItem>
                Publicação de informações
                em formatos reutilizáveis
                e acessíveis.
              </ResourceItem>

            </ResourceList>

            <Text>
              Arquivos exclusivamente baseados
              em imagens digitalizadas,
              sem reconhecimento textual,
              podem comprometer a acessibilidade
              para pessoas que utilizam
              tecnologias assistivas.
            </Text>

            <Text>
              Por esse motivo,
              o portal busca priorizar
              documentos acessíveis,
              pesquisáveis e navegáveis,
              em conformidade com diretrizes
              de transparência pública,
              governo digital e acessibilidade.
            </Text>

            <Text>
              A disponibilização de dados abertos
              também contribui para:
            </Text>

            <ResourceList>

              <ResourceItem>
                Transparência ativa.
              </ResourceItem>

              <ResourceItem>
                Controle social.
              </ResourceItem>

              <ResourceItem>
                Reutilização das informações públicas.
              </ResourceItem>

              <ResourceItem>
                Integração com ferramentas analíticas.
              </ResourceItem>

              <ResourceItem>
                Ampliação do acesso à informação.
              </ResourceItem>

            </ResourceList>

            <Text>
              O portal busca manter evolução contínua
              na publicação de conteúdos digitais acessíveis,
              observando boas práticas
              de acessibilidade,
              interoperabilidade
              e governança digital.
            </Text>
          </Section>

          {/* CANAL DE ACESSIBILIDADE */}

          <Section>
            <SubTitle>
              Canal de acessibilidade e relato de barreiras digitais
            </SubTitle>

            <Text>
              Caso o cidadão encontre dificuldades
              de navegação, barreiras de acessibilidade,
              documentos inacessíveis
              ou funcionalidades incompatíveis
              com tecnologias assistivas,
              poderá encaminhar solicitação,
              sugestão ou relato aos canais oficiais
              de atendimento do órgão.
            </Text>

            <Text>
              O portal busca promover melhoria contínua
              das condições de acessibilidade digital,
              usabilidade e inclusão,
              observando princípios de transparência,
              participação social
              e acesso universal à informação.
            </Text>

            <Text>
              Entre os exemplos de barreiras digitais
              que podem ser comunicadas estão:
            </Text>

            <ResourceList>

              <ResourceItem>
                Documentos PDF não pesquisáveis.
              </ResourceItem>

              <ResourceItem>
                Imagens sem descrição textual.
              </ResourceItem>

              <ResourceItem>
                Problemas de contraste visual.
              </ResourceItem>

              <ResourceItem>
                Falhas na navegação por teclado.
              </ResourceItem>

              <ResourceItem>
                Conteúdos incompatíveis
                com leitores de tela.
              </ResourceItem>

              <ResourceItem>
                Dificuldades de acesso
                em dispositivos móveis.
              </ResourceItem>

            </ResourceList>

            <Text>
              Solicitações relacionadas à acessibilidade
              poderão ser encaminhadas
              aos canais institucionais
              de Ouvidoria ou Serviço de Informação ao Cidadão (SIC),
              conforme regulamentação vigente.
            </Text>

            <Text>
              Recomenda-se que o cidadão informe:
            </Text>

            <ResourceList>

              <ResourceItem>
                Página onde ocorreu o problema.
              </ResourceItem>

              <ResourceItem>
                Descrição detalhada da dificuldade encontrada.
              </ResourceItem>

              <ResourceItem>
                Tecnologia assistiva utilizada,
                quando aplicável.
              </ResourceItem>

              <ResourceItem>
                Navegador ou dispositivo utilizado.
              </ResourceItem>

            </ResourceList>

            <Text>
              O órgão busca avaliar continuamente
              as manifestações recebidas,
              promovendo ajustes técnicos
              e aperfeiçoamentos necessários
              para ampliação da acessibilidade digital.
            </Text>
          </Section>

          {/* LGPD E GOVERNANÇA DIGITAL */}

          <Section>
            <SubTitle>
              Privacidade, proteção de dados e governança digital
            </SubTitle>

            <Text>
              Este portal observa princípios de proteção
              de dados pessoais,
              transparência pública,
              acessibilidade digital
              e governança eletrônica,
              buscando garantir segurança,
              integridade e confiabilidade
              das informações disponibilizadas ao cidadão.
            </Text>

            <Text>
              O tratamento de dados pessoais realizado
              pelos sistemas institucionais
              segue diretrizes da
              Lei Geral de Proteção de Dados Pessoais (LGPD)
              — Lei nº 13.709/2018 —
              observando princípios de finalidade,
              necessidade,
              adequação,
              transparência
              e segurança da informação.
            </Text>

            <Text>
              A disponibilização de serviços digitais
              busca assegurar:
            </Text>

            <ResourceList>

              <ResourceItem>
                Acesso público facilitado às informações.
              </ResourceItem>

              <ResourceItem>
                Navegação acessível e responsiva.
              </ResourceItem>

              <ResourceItem>
                Proteção de dados pessoais.
              </ResourceItem>

              <ResourceItem>
                Transparência institucional.
              </ResourceItem>

              <ResourceItem>
                Compatibilidade com tecnologias assistivas.
              </ResourceItem>

              <ResourceItem>
                Disponibilidade contínua dos serviços digitais.
              </ResourceItem>

            </ResourceList>

            <Text>
              O portal busca reduzir barreiras digitais
              que possam dificultar o acesso
              de cidadãos aos serviços públicos,
              especialmente pessoas com deficiência,
              idosos
              ou usuários com limitações tecnológicas.
            </Text>

            <Text>
              As ferramentas de acessibilidade disponíveis
              não exigem autenticação prévia,
              cadastros obrigatórios,
              fornecimento de CPF
              ou validações que possam comprometer
              o acesso universal à informação pública.
            </Text>

            <Text>
              O ambiente digital institucional
              busca manter evolução contínua
              em conformidade com:
            </Text>

            <ResourceList>

              <ResourceItem>
                Lei Geral de Proteção de Dados (LGPD).
              </ResourceItem>

              <ResourceItem>
                Lei do Governo Digital.
              </ResourceItem>

              <ResourceItem>
                Lei de Acesso à Informação.
              </ResourceItem>

              <ResourceItem>
                Diretrizes de acessibilidade digital.
              </ResourceItem>

              <ResourceItem>
                Boas práticas de transparência pública.
              </ResourceItem>

            </ResourceList>

            <Text>
              A administração pública reconhece
              a acessibilidade digital
              e a proteção de dados pessoais
              como elementos fundamentais
              para promoção da cidadania,
              inclusão social
              e transformação digital responsável.
            </Text>
          </Section>

          {/* DECLARAÇÃO DE CONFORMIDADE */}

          <Section>
            <SubTitle>
              Declaração de conformidade em acessibilidade digital
            </SubTitle>

            <Text>
              Este portal institucional busca manter conformidade
              contínua com práticas de acessibilidade digital,
              usabilidade,
              transparência pública
              e inclusão social,
              observando recomendações técnicas
              aplicáveis à administração pública brasileira.
            </Text>

            <Text>
              A estrutura do portal foi desenvolvida
              considerando diretrizes do
              Modelo de Acessibilidade em Governo Eletrônico (eMAG),
              recomendações internacionais WCAG
              (Web Content Accessibility Guidelines)
              e princípios previstos na legislação brasileira
              de inclusão e acesso à informação.
            </Text>

            <Text>
              Entre os recursos implementados
              no ambiente digital estão:
            </Text>

            <ResourceList>

              <ResourceItem>
                Navegação por teclado.
              </ResourceItem>

              <ResourceItem>
                Estrutura semântica compatível
                com leitores de tela.
              </ResourceItem>

              <ResourceItem>
                Redimensionamento de texto.
              </ResourceItem>

              <ResourceItem>
                Ferramenta de alto contraste.
              </ResourceItem>

              <ResourceItem>
                Compatibilidade com tecnologias assistivas.
              </ResourceItem>

              <ResourceItem>
                Organização hierárquica do conteúdo.
              </ResourceItem>

              <ResourceItem>
                Identificação acessível de elementos interativos.
              </ResourceItem>

            </ResourceList>

            <Text>
              O portal busca promover melhoria contínua
              das condições de acessibilidade,
              podendo realizar atualizações técnicas,
              revisões estruturais
              e aperfeiçoamentos periódicos
              conforme evolução tecnológica,
              alterações normativas
              e necessidades identificadas pelos usuários.
            </Text>

            <Text>
              Eventuais inconsistências de acessibilidade
              poderão ser comunicadas
              pelos canais institucionais de atendimento,
              permitindo análise técnica
              e adoção das medidas necessárias.
            </Text>

            <Text>
              A administração pública reafirma
              seu compromisso com:
            </Text>

            <ResourceList>

              <ResourceItem>
                Inclusão digital.
              </ResourceItem>

              <ResourceItem>
                Transparência pública.
              </ResourceItem>

              <ResourceItem>
                Acesso universal à informação.
              </ResourceItem>

              <ResourceItem>
                Transformação digital responsável.
              </ResourceItem>

              <ResourceItem>
                Prestação acessível de serviços públicos.
              </ResourceItem>

            </ResourceList>

            <Text>
              A acessibilidade digital constitui
              instrumento essencial para promoção
              da cidadania,
              participação social
              e fortalecimento da transparência institucional.
            </Text>
          </Section>
          </TextContainer>
      </main>
    </>
  );
}     